import { render, staticRenderFns } from "./MessageResourcesDisplay.vue?vue&type=template&id=7ec2fd5d&scoped=true"
import script from "./MessageResourcesDisplay.vue?vue&type=script&lang=ts"
export * from "./MessageResourcesDisplay.vue?vue&type=script&lang=ts"
import style0 from "./MessageResourcesDisplay.vue?vue&type=style&index=0&id=7ec2fd5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2fd5d",
  null
  
)

export default component.exports